import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {AsyncPipe} from '@angular/common';
import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule,} from '@angular/forms';
import {MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger,} from '@angular/material/autocomplete';
import {MatChipGrid, MatChipInput, MatChipRemove, MatChipRow} from '@angular/material/chips';
import {MatOption} from '@angular/material/core';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {Tag} from '@app/tag/models';
import {TagService} from '@app/tag/tag.service';
import {forkJoin, Observable, of} from 'rxjs';
import {mergeMap} from 'rxjs/operators';

@Component({
    selector: 'frog-tag-picker',
    templateUrl: './tag-picker.component.html',
    styleUrls: ['./tag-picker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: TagPickerComponent,
        },
    ],
    imports: [
        MatFormField,
        MatLabel,
        MatChipGrid,
        MatChipRow,
        MatChipRemove,
        MatIcon,
        ReactiveFormsModule,
        MatAutocompleteTrigger,
        MatChipInput,
        MatAutocomplete,
        MatOption,
        AsyncPipe,
    ],
})
export class TagPickerComponent implements OnInit, ControlValueAccessor {
    @ViewChild('tagInput') tagInput: ElementRef<HTMLInputElement>;
    separatorKeysCodes: number[] = [ENTER, COMMA];
    tagControl: FormControl;
    filteredTags$: Observable<Tag[]>;
    tags: Tag[];
    allTags: Tag[];

    onChange = (Tag) => {};
    onTouched = () => {};
    touched = false;
    disabled = false;

    constructor(private tagService: TagService) {
        this.tags = [];
        this.allTags = [];
        this.tagControl = new FormControl('');
    }

    writeValue(tags: string[]): void {
        if (tags !== null) {
            const observables = tags.map((tagName) => this.tagService.resolveName(tagName));
            forkJoin(observables).subscribe((tags) => (this.tags = tags));
        }
    }

    registerOnChange(callback: any): void {
        this.onChange = callback;
    }

    registerOnTouched(callback: any): void {
        this.onTouched = callback;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    ngOnInit(): void {
        this.filteredTags$ = this.tagService.autocomplete('').pipe(
            mergeMap(() => {
                return this.tagControl.valueChanges;
            }),
            // debounceTime(150),
            mergeMap((value) => {
                if (typeof value === 'string') {
                    return this.tagService.autocomplete(value.toLocaleLowerCase());
                }
                return of([]);
            }),
        );
    }

    remove(tag: Tag): void {
        const index = this.tags.indexOf(tag);
        if (index >= 0) {
            this.markAsTouched();
            this.tags.splice(index, 1);
            this.onChange(this.tags);
        }
    }

    selected(event: MatAutocompleteSelectedEvent): void {
        const user = event.option.value;
        const index = this.tags.indexOf(user);
        if (index === -1) {
            this.markAsTouched();
            this.tags.push(event.option.value);
            this.onChange(this.tags);
        }

        this.tagInput.nativeElement.value = '';
    }

    private filter(value: string): Tag[] {
        return this.allTags.filter((x) => !this.tags.includes(x));
    }

    private markAsTouched(): void {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }
}
